var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{key:_vm.illustrationUrl,staticClass:"illustration-header",domProps:{"innerHTML":_vm._s(_vm.coloredSVG)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }